import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function MailIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="m2 4.875 4.899 3.572c.397.29.595.434.81.49.191.05.39.05.581 0 .216-.056.414-.2.811-.49L14 4.875M4.88 13h6.24c1.008 0 1.512 0 1.897-.204.339-.18.614-.467.787-.82C14 11.576 14 11.05 14 10V6c0-1.05 0-1.575-.196-1.976a1.84 1.84 0 0 0-.787-.82C12.632 3 12.128 3 11.12 3H4.88c-1.008 0-1.512 0-1.897.204a1.84 1.84 0 0 0-.787.82C2 4.424 2 4.95 2 6v4c0 1.05 0 1.575.196 1.976.173.353.448.64.787.82.385.204.889.204 1.897.204" /></svg>
  );
}

export default MailIcon;
